<template>
  <section>
    <div
      v-if="showAddButton === true && givenPublication.slug"
      class="container mx-auto px-4 flex"
    >
      <button
        class="outline-link outline-link-primary mt-8 mx-3"
        style="transition: all 0.15s ease 0s;"
        @click="setPublication()"
      >
        {{ $t('GIVE_AWAY_BOOK') }}
      </button>
      <button
        class="outline-link outline-link-primary mt-8 mx-3"
        style="transition: all 0.15s ease 0s;"
        @click="setExchangePublication()"
      >
        {{ $t('WANT_BOOK') }}
      </button>
    </div>
    <add-market
      v-if="showModal === true"
      :given-publication="publication"
      :given-exchange="exchange"
      @showAddMarket="handleShowNewMarket($event)"
    />
  </section>
</template>
  
<script>
import { defineAsyncComponent } from "vue";
import axios from "axios";
const AddMarket = defineAsyncComponent(() =>
  import("./AddMarket" /* webpackChunkName: "add-market-detail" */)
);
  
export default {
  name: "AddMarketWrapper",
  components: {
    AddMarket
  },
  inject: ['dataset'],
  data() {
    return {
      showModal: false,
      showAddButton: false,
      givenPublication: {},
      publication: {},
      exchange: {}
    };
  },
  async created() {
    await this.setProps();
  },
  mounted() {
    this.intervalid1 = setInterval(function(){
      if (typeof window.localStorage.getItem('logged-in') === 'undefined' || window.localStorage.getItem('logged-in') === null) {
        this.showAddButton =  false;
      }
      this.showAddButton = (window.localStorage.getItem('logged-in') === 'true');
    }.bind(this), 500);
  
    this.retrieveItems();
  },
  methods: {
    setProps() {
      (this.dataset.slug) ? this.givenPublicationSlug = this.dataset.slug : '';
    },
    setExchangePublication() {
      this.publication = {};
      this.exchange = this.givenPublication;
      this.handleShowNewMarket(true);
    },
    setPublication() {
      this.exchange = {};
      this.publication = this.givenPublication;
      this.handleShowNewMarket(true);
    },
    handleShowNewMarket(data) {
      if (data === false) {
        document.getElementById('header').classList.remove("hidden");
        document.querySelector("html").classList.remove("overflow-hidden");
      } else {
        document.getElementById('header').classList.add("hidden");
        document.querySelector("html").classList.add("overflow-hidden");
      }
      this.showModal = data;
    },
    retrieveItems() {
      axios.get('/fe/api/publication/detail/' + this.givenPublicationSlug)
        .then((response) => {
          this.givenPublication = response.data;
        })
        .catch((e) => {
        });
    }
  }
}
</script>
  